import {Box, css, styled} from '@mui/material';
import {SectionContainerProps} from './types';

export const SectionContainer = styled(Box)<SectionContainerProps>`
	border-radius: 8px;
	border: 1px solid ${({theme}) => theme.palette.grey[300]};
	background: ${({theme}) => theme.palette.grey[100]};
	padding: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;

	${({$isInverse}) =>
		$isInverse &&
		css`
			background: none;
			border: none;
			justify-content: flex-start;
			padding-inline: 0px;
		`}
`;
